import axios from "axios";
import { CognitoIdentityClient } from "@aws-sdk/client-cognito-identity";
import { fromCognitoIdentity } from "@aws-sdk/credential-provider-cognito-identity";

import {
  PERSONAL_CONFIRM_IMAGE_AT,
  INCOME_CERTIFICATE_IMAGE_AT,
} from "@/constants/constant";
import store from "@/store";

const IDENTITY_POOL_ID = process.env.VUE_APP_IDENTITY_POOL_ID;
const REGION = "ap-northeast-1";
export const USER_SESSION = "user_session";

export function initCredentials(pageId = "", authKind) {
  return new Promise(function (resolve, reject) {
    if (pageId) {
      checkCredentials(pageId, authKind).then(
        (res) => {
          resolve(res);
        },
        (reason) => {
          return reject(reason);
        }
      );
    } else {
      resolve();
    }
  });
}

export function initializCredentials(loginType, redirectPageId = "") {
  return new Promise(function (resolve, reject) {
    let data = {
      login_type: loginType,
    };
    if (redirectPageId) {
      data["redirect_page_id"] = redirectPageId;
    }
    axios
      .post(process.env.VUE_APP_API_AUTH_INITIALIZ_URL, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        // console.log('res', res.data)
        if (!res.data.status === "NG") {
          reject(new Error("fail to auth/initializ"));
        }
        let result = res.data.result;
        // 成功時処理
        // console.log('result', result)
        setUserSessionCookie(result.user_session);
        // initAwsConfing(result.IdentityId, result.Token)
        resolve(result);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function authLogout() {
  return new Promise(function (resolve, reject) {
    let data = {
      user_session: getUserSessionCookie(),
    };
    axios
      .post(process.env.VUE_APP_API_AUTH_LOGOUT_URL, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        resolve(res);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

function checkCredentials(pageId, authKind) {
  return new Promise(function (resolve, reject) {
    // console.log('USER_SESSION', getUserSessionCookie())
    let data = {
      user_session: getUserSessionCookie(),
      page: pageId,
    };
    if (authKind) data.auth_kind = authKind;
    axios
      .post(process.env.VUE_APP_API_AUTH_CHECK_URL, JSON.stringify(data), {
        headers: { "Content-Type": "application/json" },
      })
      .then((res) => {
        // console.log('check result', res)
        store.dispatch("setProhibitedAction", res.data.prohibited_action);
        store.dispatch("setProhibitedPages", res.data.prohibited_pages);
        let result = res.data.result;
        if (res.data.status === "NG") {
          // サーバが失敗を返した場合
          reject(result);
          return;
        }
        // 成功時処理
        if (result.check_result === "OK") {
          setUserSessionCookie(result.user_session);
          store.dispatch("setIdentityId", result.identity_id);
          store.dispatch("setCognitoToken", result.cognito_token);
        }
        resolve(result);
      })
      .catch((error) => {
        // console.log('check error' + error)
        reject(error);
      });
  });
}

// $cookiesにuser_sessionを保存  有効期限 15分 secure
export function setUserSessionCookie(userSession) {
  if (userSession) {
    // document.cookie = 'user_session=' + userSession + ';max-age=900; path=/' + (process.env.VUE_APP_COOKIES_SECURE === 'true' ? '; secure' : '')
    window.$cookies.set(
      USER_SESSION,
      userSession,
      "15min",
      "/",
      null,
      process.env.VUE_APP_COOKIES_SECURE
    );
  }
}

// $cookiesからuser_sessionを取得
export function getUserSessionCookie() {
  if (window.$cookies.isKey(USER_SESSION)) {
    return window.$cookies.get(USER_SESSION);
  }
  return "";
}

// $cookiesからuser_sessionを削除
export function removeUserSessionCookie() {
  window.$cookies.remove(USER_SESSION, "/");
}

export function removeAllCookie() {
  removeUserSessionCookie();
  window.$cookies.remove(PERSONAL_CONFIRM_IMAGE_AT, "/");
  window.$cookies.remove(INCOME_CERTIFICATE_IMAGE_AT, "/");
}

export function getAwsCredentials() {
  return fromCognitoIdentity({
    client: new CognitoIdentityClient({ region: REGION }),
    identityPoolId: IDENTITY_POOL_ID,
    identityId: store.getters.getIdentityId,
    logins: {
      "cognito-identity.amazonaws.com": store.getters.getCognitoToken,
    },
  });
}